// extracted by mini-css-extract-plugin
export var value = "index-module--value--L_Mdd";